(function () {
  'use strict';

  /* Header: transparent on top of home, solid after scroll */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 40 || header.classList.contains('is-searching'));
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    var burger = header.querySelector('.header-burger');
    var nav = header.querySelector('.site-header__nav');
    if (burger && nav) {
      burger.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        header.classList.toggle('is-solid', open || window.scrollY > 40);
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* Header: inline search field opening in place of the magnifier */
    var search = header.querySelector('[data-header-search]');
    var searchToggle = search && search.querySelector('[data-search-toggle]');
    var searchInput = search && search.querySelector('.header-search__input');
    if (search && searchToggle && searchInput) {
      var isSearchOpen = function () {
        return search.classList.contains('is-open');
      };
      var setSearchOpen = function (open) {
        search.classList.toggle('is-open', open);
        header.classList.toggle('is-searching', open);
        header.classList.toggle('is-solid', open || window.scrollY > 40);
        searchToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          searchInput.removeAttribute('tabindex');
          searchInput.focus();
        } else {
          searchInput.setAttribute('tabindex', '-1');
          searchInput.value = '';
        }
      };

      searchToggle.addEventListener('click', function (event) {
        if (!isSearchOpen()) {
          event.preventDefault();
          setSearchOpen(true);
        } else if (!searchInput.value.trim()) {
          event.preventDefault();
          setSearchOpen(false);
        }
      });

      search.addEventListener('submit', function (event) {
        if (!searchInput.value.trim()) event.preventDefault();
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isSearchOpen()) {
          setSearchOpen(false);
          searchToggle.focus();
        }
      });

      document.addEventListener('click', function (event) {
        if (isSearchOpen() && !search.contains(event.target)) setSearchOpen(false);
      });
    }
  }

  /* Product gallery: click thumbnail to swap main image */
  document.querySelectorAll('.product-gallery').forEach(function (gallery) {
    var main = gallery.querySelector('.product-gallery__main img');
    if (!main) return;
    var moreButton = gallery.querySelector('[data-gallery-more]');
    if (moreButton) {
      moreButton.addEventListener('click', function () {
        gallery.querySelectorAll('[data-gallery-extra]').forEach(function (thumb) { thumb.removeAttribute('hidden'); });
        moreButton.remove();
      });
    }
    gallery.querySelectorAll('.product-gallery__thumbs img').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mainSrc = main.getAttribute('src');
        var mainSrcset = main.getAttribute('srcset') || '';
        main.setAttribute('src', thumb.getAttribute('src'));
        main.setAttribute('srcset', thumb.getAttribute('srcset') || '');
        main.setAttribute('alt', thumb.getAttribute('alt') || '');
        thumb.setAttribute('src', mainSrc);
        if (mainSrcset) thumb.setAttribute('srcset', mainSrcset);
      });
    });
  });

  /* Collection: sort select */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* Localization: auto-submit selectors + first-visit browser-language detection */
  document.querySelectorAll('[data-localization-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      try { localStorage.setItem('sabran-locale-chosen', '1'); } catch (e) { /* private mode */ }
      if (select.form) select.form.submit();
    });
  });
  (function () {
    var dataEl = document.getElementById('sabran-localization');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!data || !data.languages || data.languages.length < 2) return;
    try {
      if (localStorage.getItem('sabran-locale-chosen')) return;
      localStorage.setItem('sabran-locale-chosen', '1');
      var pref = (navigator.language || '').split('-')[0].toLowerCase();
      var currentBase = (data.current || '').split('-')[0].toLowerCase();
      if (!pref || pref === currentBase) return;
      var target = null;
      var current = null;
      data.languages.forEach(function (language) {
        if (language.iso.split('-')[0].toLowerCase() === pref) target = language;
        if (language.iso === data.current) current = language;
      });
      if (!target) return;
      var path = window.location.pathname;
      if (current && current.root !== '/' && path.indexOf(current.root) === 0) {
        path = path.slice(current.root.length) || '/';
      }
      var root = target.root === '/' ? '' : target.root;
      window.location.replace(root + path + window.location.search);
    } catch (e) { /* localStorage unavailable */ }
  })();

  /* Analytics helpers (no-ops when trackers absent or consent withheld) */
  function canTrack() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function') {
        return cp.analyticsProcessingAllowed();
      }
    } catch (e) { /* fall through */ }
    return true;
  }
  function track(gaEvent, gaPayload, fbEvent, fbPayload) {
    if (!canTrack()) return;
    if (typeof window.gtag === 'function' && gaEvent) window.gtag('event', gaEvent, gaPayload || {});
    if (typeof window.fbq === 'function' && fbEvent) window.fbq('track', fbEvent, fbPayload || {});
  }

  function setOptionalText(el, value) {
    if (!el) return;
    el.textContent = value || '';
    el.hidden = !value;
  }

  /* Product card: variant pickers (colors/sizes) + price and button sync */
  document.querySelectorAll('[data-card-product]').forEach(function (card) {
    var dataEl = card.querySelector('[data-card-variants]');
    var form = card.querySelector('form[data-product-form]');
    if (!dataEl || !form) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var addButton = card.querySelector('[data-add-to-cart]');
    var priceEl = card.querySelector('[data-card-price]');
    var compareEl = card.querySelector('[data-card-compare-price]');
    var discountEl = card.querySelector('[data-card-discount]');
    var groups = card.querySelectorAll('[data-option-group]');
    var selected = [];
    groups.forEach(function (group, index) {
      var current = group.querySelector('.is-selected');
      selected[index] = current ? current.dataset.optionValue : null;
      group.querySelectorAll('[data-option-value]').forEach(function (button) {
        button.addEventListener('click', function () {
          selected[index] = button.dataset.optionValue;
          group.querySelectorAll('[data-option-value]').forEach(function (other) {
            other.classList.toggle('is-selected', other === button);
            other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
          });
          update();
        });
      });
    });
    function update() {
      var candidates = variants.filter(function (variant) {
        return variant.options.every(function (value, i) { return selected[i] === null || value === selected[i]; });
      });
      var match = candidates[0];
      if (!match) {
        if (addButton) {
          addButton.disabled = true;
          addButton.textContent = addButton.dataset.unavailableLabel || addButton.textContent;
        }
        return;
      }
      var available = candidates.some(function (variant) { return variant.available; });
      if (selected.every(function (value) { return value !== null; })) {
        var idInput = form.querySelector('[data-variant-id]');
        if (idInput) idInput.value = match.id;
        form.dataset.id = match.id;
        form.dataset.price = match.price_decimal;
        form.dataset.comparePrice = match.compare_at_cents;
      }
      if (priceEl) priceEl.textContent = match.price;
      setOptionalText(compareEl, match.compare_at_price);
      setOptionalText(discountEl, match.discount);
      if (addButton) {
        addButton.disabled = !available;
        addButton.textContent = available
          ? (addButton.dataset.addLabel || addButton.textContent)
          : (addButton.dataset.soldOutLabel || addButton.textContent);
      }
    }
  });

  /* Required options (size): block add to cart and express checkout until chosen */
  function productScope(form) {
    return form.closest('[data-card-product]') || form;
  }
  function missingRequiredOption(form) {
    var groups = productScope(form).querySelectorAll('[data-option-required]');
    for (var i = 0; i < groups.length; i++) {
      if (!groups[i].querySelector('.is-selected')) return groups[i];
    }
    return null;
  }
  function flagMissingOption(group) {
    group.classList.add('is-invalid');
    var error = group.nextElementSibling;
    if (error && error.hasAttribute('data-option-error')) error.hidden = false;
    group.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
  document.querySelectorAll('[data-option-required]').forEach(function (group) {
    group.addEventListener('click', function (event) {
      if (!event.target.closest('[data-option-value]')) return;
      group.classList.remove('is-invalid');
      var error = group.nextElementSibling;
      if (error && error.hasAttribute('data-option-error')) error.hidden = true;
    });
  });
  document.querySelectorAll('[data-dynamic-checkout]').forEach(function (wrapper) {
    var form = wrapper.closest('form');
    if (!form) return;
    wrapper.addEventListener('click', function (event) {
      var missing = missingRequiredOption(form);
      if (!missing) return;
      event.preventDefault();
      event.stopPropagation();
      flagMissingOption(missing);
    }, true);
  });

  /* Cart added modal */
  var cartModal = document.querySelector('[data-cart-modal]');
  function formatMoney(cents) {
    var format = (cartModal && cartModal.dataset.moneyFormat) || '{{amount_with_comma_separator}} €';
    var amount = (cents / 100).toFixed(2);
    var withComma = amount.replace('.', ',');
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      if (key === 'amount_no_decimals') return String(Math.round(cents / 100));
      if (key === 'amount_no_decimals_with_comma_separator') return String(Math.round(cents / 100));
      return key === 'amount' ? amount : withComma;
    });
  }
  function sizedImage(url, width) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }
  function fillTemplate(format, key, value) {
    return (format || '').replace(key, value);
  }
  function referencePrice(item, comparePrice) {
    return Math.max(parseInt(comparePrice || '0', 10) || 0, item.original_price || 0);
  }
  function setModalDiscount(item, comparePrice) {
    var compareEl = cartModal.querySelector('[data-cart-modal-compare]');
    var discountEl = cartModal.querySelector('[data-cart-modal-discount]');
    var savingEl = cartModal.querySelector('[data-cart-modal-saving]');
    var quantity = item.quantity || 1;
    var reference = referencePrice(item, comparePrice);
    var hasDiscount = typeof item.final_price === 'number' && reference > item.final_price;
    if (!hasDiscount) {
      setOptionalText(compareEl, '');
      setOptionalText(discountEl, '');
      setOptionalText(savingEl, '');
      return;
    }
    var percent = Math.round(((reference - item.final_price) / reference) * 100);
    setOptionalText(compareEl, formatMoney(reference * quantity));
    setOptionalText(discountEl, fillTemplate(cartModal.dataset.discountFormat, 'PERCENT', String(percent)));
    setOptionalText(savingEl, fillTemplate(cartModal.dataset.savingFormat, 'AMOUNT', formatMoney((reference - item.final_price) * quantity)));
  }
  function openCartModal(item, comparePrice) {
    if (!cartModal) return;
    var imageEl = cartModal.querySelector('[data-cart-modal-image]');
    if (imageEl) {
      imageEl.src = sizedImage(item.image, 160);
      imageEl.alt = item.product_title || '';
      imageEl.hidden = !item.image;
    }
    setOptionalText(cartModal.querySelector('[data-cart-modal-product]'), item.product_title);
    setOptionalText(cartModal.querySelector('[data-cart-modal-variant]'), item.variant_title);
    setOptionalText(cartModal.querySelector('[data-cart-modal-price]'), typeof item.final_line_price === 'number' ? formatMoney(item.final_line_price) : '');
    setModalDiscount(item, comparePrice);
    cartModal.hidden = false;
    document.body.classList.add('cart-modal-open');
  }
  function closeCartModal() {
    if (!cartModal || cartModal.hidden) return;
    cartModal.hidden = true;
    document.body.classList.remove('cart-modal-open');
  }
  if (cartModal) {
    cartModal.querySelectorAll('[data-cart-modal-close]').forEach(function (el) {
      el.addEventListener('click', closeCartModal);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeCartModal();
    });
  }

  /* Product form: AJAX add to cart + add_to_cart events */
  document.querySelectorAll('form[data-product-form]').forEach(function (form) {
    form.addEventListener('submit', function (event) {
      event.preventDefault();
      var missing = missingRequiredOption(form);
      if (missing) {
        flagMissingOption(missing);
        return;
      }
      var button = form.querySelector('[data-add-to-cart]');
      var payload = form.dataset;
      fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'application/json' },
        body: new URLSearchParams(new FormData(form))
      })
        .then(function (response) {
          if (!response.ok) throw new Error('add-to-cart failed');
          return response.json();
        })
        .then(function (item) {
          track(
            'add_to_cart',
            { currency: payload.currency, value: parseFloat(payload.price || '0'), items: [{ item_id: payload.sku || payload.id, item_name: payload.title, price: parseFloat(payload.price || '0'), quantity: 1 }] },
            'AddToCart',
            { content_ids: [payload.id], content_name: payload.title, content_type: 'product', value: parseFloat(payload.price || '0'), currency: payload.currency }
          );
          if (button) {
            var original = button.textContent;
            button.textContent = button.dataset.addedLabel || original;
            button.classList.add('is-added');
            window.setTimeout(function () {
              button.textContent = original;
              button.classList.remove('is-added');
            }, 1500);
          }
          var bubble = document.querySelector('.cart-count-bubble');
          if (bubble) bubble.textContent = String(parseInt(bubble.textContent || '0', 10) + 1);
          openCartModal(item, payload.comparePrice);
        })
        .catch(function () {
          form.submit();
        });
    });
  });

  /* Cart page: discount codes (Cart Ajax API + section rendering) */
  function cartRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }
  function updateCartDiscounts(codes) {
    return fetch(cartRoot() + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(',') })
    }).then(function (response) {
      if (!response.ok) throw new Error('cart update failed');
      return response.json();
    });
  }
  function renderCartSection(sectionId) {
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(sectionId), { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        var wrapper = document.getElementById('shopify-section-' + sectionId);
        if (!wrapper || !data[sectionId]) throw new Error('section missing');
        var fresh = new DOMParser().parseFromString(data[sectionId], 'text/html').querySelector('.shopify-section');
        wrapper.innerHTML = fresh ? fresh.innerHTML : data[sectionId];
      });
  }
  function refreshCartOrReload(box) {
    return renderCartSection(box.dataset.sectionId).catch(function () { window.location.reload(); });
  }
  function setDiscountState(box, isLoading, hasError) {
    var apply = box.querySelector('[data-discount-apply]');
    var error = box.querySelector('[data-discount-error]');
    if (apply) apply.disabled = isLoading;
    if (error) error.hidden = !hasError;
    box.querySelectorAll('[data-discount-remove]').forEach(function (el) { el.disabled = isLoading; });
  }
  function appliedDiscountCodes(box) {
    return (box.dataset.discountCodes || '').split(',').filter(Boolean);
  }
  function isCodeApplied(cart, code) {
    return (cart.discount_codes || []).some(function (entry) {
      return entry.applicable && String(entry.code).toLowerCase() === code.toLowerCase();
    });
  }
  function fallbackDiscountRedirect(code) {
    var redirect = encodeURIComponent(window.location.pathname);
    window.location.href = cartRoot() + 'discount/' + encodeURIComponent(code) + '?redirect=' + redirect;
  }
  function applyDiscountCode(box) {
    var input = box.querySelector('[data-discount-input]');
    var code = input ? input.value.trim() : '';
    if (!code) return;
    var existing = appliedDiscountCodes(box);
    setDiscountState(box, true, false);
    updateCartDiscounts(existing.concat(code))
      .then(function (cart) {
        if (!cart.discount_codes) return fallbackDiscountRedirect(code);
        if (isCodeApplied(cart, code)) return refreshCartOrReload(box);
        return updateCartDiscounts(existing).then(function () { setDiscountState(box, false, true); });
      })
      .catch(function () { setDiscountState(box, false, true); });
  }
  function removeDiscountCode(box, code) {
    var remaining = appliedDiscountCodes(box).filter(function (entry) { return entry.toLowerCase() !== code.toLowerCase(); });
    setDiscountState(box, true, false);
    updateCartDiscounts(remaining)
      .then(function () { return refreshCartOrReload(box); })
      .catch(function () { setDiscountState(box, false, true); });
  }
  document.addEventListener('click', function (event) {
    var applyButton = event.target.closest('[data-discount-apply]');
    var removeButton = event.target.closest('[data-discount-remove]');
    var box = event.target.closest('[data-cart-discount]');
    if (!box) return;
    if (applyButton) applyDiscountCode(box);
    if (removeButton) removeDiscountCode(box, removeButton.dataset.code || '');
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' || !event.target.matches('[data-discount-input]')) return;
    event.preventDefault();
    var box = event.target.closest('[data-cart-discount]');
    if (box) applyDiscountCode(box);
  });

  /* Checkout button: begin_checkout / InitiateCheckout */
  document.querySelectorAll('[data-checkout-button]').forEach(function (button) {
    button.addEventListener('click', function () {
      track(
        'begin_checkout',
        { currency: button.dataset.currency, value: parseFloat(button.dataset.value || '0') },
        'InitiateCheckout',
        { value: parseFloat(button.dataset.value || '0'), currency: button.dataset.currency }
      );
    });
  });
})();